<script setup lang="ts">
import {Component} from "../types.ts";

defineProps<{
  item: Component
}>();


</script>
<template>
  <div v-bind="item.props">
    <div :id="`text-${item.props.id}`" v-html="item.published.src" :style="{position: 'absolute', left: item.text_props?.x_indent ?? 'unset', top: item.text_props?.y_indent ?? 'unset'}">
    </div>
     <slot>
    </slot>

  </div>
</template>

<style scoped>

</style>